<template>
  <div class="container container-fluid">
    <div class="d-flex justify-content-between align-items-center">
      <!-- INPUT PARA BUSCAR -->
      <div class="col-md-3 pt-4">
        <input
          v-model="searchTable"
          type="text"
          class="form-control"
          placeholder="Buscar en la tabla..."
        />
      </div>
    </div>

    <div class="table-container-scrollable-users my-3">
      <table
        class="table table-striped table-hover table-bordered text-center table-rounded mt-2"
      >
        <thead class="table-secondary">
          <tr>
            <th>
              <div class="d-flex justify-content-between align-items-center">
                <div
                  @click="sortColumn('id')"
                  :class="{
                    'sort-asc': sortOrder.id === 1,
                    'sort-desc': sortOrder.id === -1,
                  }"
                ></div>

                <div class="">ID</div>
              </div>
            </th>
            <th>Usuario</th>
            <th>Email</th>
            <th>Tipo Rol</th>
            <th>Fecha de Inicio</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="(row, index) in filteredData" :key="index">

            <td>{{ row.id }}</td>
            <td>{{ row.username }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.roles[0].roleName }}</td>
            <td>{{ row.fechaFormateada }}</td>
   
            <td>
              <ul class="">
                <li>
                  <router-link
                      class="btn btn-block btn-custom"
                      href="#"
                      :to="{ name: 'UpdateUsuario', params: { id: row.id } }"
                    >
                      Editar
                    </router-link>
                </li>
              </ul> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch } from "vue";

export default {
  name: "TableUsersView",
  props: {
    dataDATA: Array,
    perPage: Number,
  },
  setup(props, context) {
    const currentPage = ref(1);
    const sortedData = ref([]);
    const searchTable = ref("");
    const totalRecords = ref(props.dataPaginado?.total ?? 0);
    const perPage = ref(props.perPage || 10);
 
    const sortOrder = ref({
      id: 1,
      name: 1,
    });
    
    const tableData = ref(props.dataDATA || []);

    const formatFecha = (createdAt) => {
      const [year, month, day] = createdAt.split('T')[0].split('-');
      return createdAt = `${day}-${month}-${year}`;
    };

    const filteredData = computed(() => {
      const search = searchTable.value.toLowerCase();
      return tableData.value.map((row) => {
        const formattedDate = formatFecha(row.createdAt);
        row.fechaFormateada = formattedDate;
        return row;
      }).filter((row) => {
        return Object.values(row)
          .filter((value) => value !== null && value !== undefined)
          .some((value) => value.toString().toLowerCase().includes(search));
      });
    });

    watch(
      () => props.perPage,
      (newPerPage) => {
        perPage.value = newPerPage;
      }
    );

    watch(
      () => props.dataDATA,
      (newData) => {
        tableData.value = [...newData];
      }
    );

    const totalPages = computed(() => {
      return props.dataPaginado ? props.dataPaginado.total_pages : 0;
    });

    const sortColumn = (column) => {
      sortOrder.value[column] = -sortOrder.value[column];
      tableData.value.sort((a, b) => {
        return (a[column] > b[column] ? 1 : -1) * sortOrder.value[column];
      });
    };

    const changePage = (page) => {
      currentPage.value = page;
      context.emit("pageChanged", page);
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value -= 1;
        context.emit('pageChanged', currentPage.value);
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value += 1;
        context.emit('pageChanged', currentPage.value);
      }
    };

    const displayedPages = computed(() => {
      const totalVisiblePages = 5;
      const startPage = Math.max(1, currentPage.value - Math.floor(totalVisiblePages / 2));
      const endPage = Math.min(totalPages.value, startPage + totalVisiblePages - 1);

      let pagesArray = [];
      for (let i = startPage; i <= endPage; i++) {
        pagesArray.push(i);
      }
      return pagesArray;
    });

    const editCompany = async (id) => {

      try {
        //const response = await apiArmas.getEntregaPersonalPdf({ id: id } );

        if (response.headers['content-type'] === 'application/pdf') {

          const blob = new Blob([response.data], { type: 'application/pdf' });

          const url = window.URL.createObjectURL(blob);

          window.open(url, '_blank');

          window.URL.revokeObjectURL(url);
        } else {
          console.error('La respuesta no es un PDF válido.');
        }
      } catch (error) {
        console.error(error);
      }
    };

    return {
      filteredData,
      displayedPages,
      tableData,
      totalRecords,
      editCompany,
      currentPage,
      sortedData,
      searchTable,
      sortOrder,
      totalPages,
      sortColumn,
      changePage,
      prevPage,
      nextPage,
    };
  },
};
</script>
